import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import type { RegistrationData } from "@/core/schemas/register.schema";

type RegistrationState = {
	registrationData: Partial<RegistrationData>;
	updateRegistrationData: (data: Partial<RegistrationData>) => void;
	resetRegistrationData: () => void;
};

export const useRegistrationStore = create<RegistrationState>()(
	persist(
		(set) => ({
			registrationData: {},
			updateRegistrationData: (newData) =>
				set((state) => ({
					registrationData: { ...state.registrationData, ...newData },
				})),
			resetRegistrationData: () => set({ registrationData: {} }),
		}),
		{
			name: "RegistrationStore",
			storage: createJSONStorage(() => sessionStorage),
		},
	),
);
